/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    import fld = ChatroomagentsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class AgentComparisonAssignedConversationGrid extends NoboxEntityGrid<ChatroomagentsRow, any> {
        protected getColumnsKey() { return AgentComparisonAssignedConversationColumn.columnsKey; }
        protected getDialogType() { return ChatroomsDialog; }
        protected getIdProperty() { return ChatroomagentsRow.idProperty; }
        protected getInsertPermission() { return ChatroomagentsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatroomagentsRow.localTextPrefix; }
        protected getService() { return ChatroomagentsService.baseUrl; }
        public ReById: number;
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];
            let listAkun = Q.getLookup("Nobox.AccountLookup").itemById as unknown as Nobox.AccountRow[];
            columns.unshift({
                field: 'Go To Conversation',
                name: '',
                format: ctx => {
                    return '<a href="javascript:;" title="Go to conversation"><i class="fa fa-share text-primary room-link"></i></a>';
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.ChId).format =
                ctx => `${Q.htmlEncode(listChannel[ctx.value] == undefined ? "-" : listChannel[ctx.value].Nm)}`;
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.ChAccId).format =
                ctx => `${Q.htmlEncode(listAkun[ctx.value] == undefined ? "-" : listAkun[ctx.value].Name)}`;

            return columns;
        }

        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatroomagentsRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };
            return flt;
        }

        //protected getQuickFilters() {
        //    return []; // I wanna this!! for example, to using with condition 
        //}

        protected getButtons() {
            var buttons = super.getButtons();
            buttons[0].visible = false;
            buttons[1].visible = false;
            buttons[2].visible = false;
            //buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
            //    grid: this,
            //    title: "Export Excel",
            //    hint: "Export Excel",
            //    service: ChatroomsService.baseUrl + '/ListExcel',
            //    onViewSubmit: () => this.onViewSubmit(),
            //    separator: true
            //}));
            return [];
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("room-link")) {
                window.open("/Messages/Inbox?RoomId=" + item.RoomId)
            }
        }

        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            var $this = this;
            if (this.ReById != undefined) {
                var equalFilter = request.EqualityFilter as ChatroomagentsRow;
                equalFilter.UserId = this.ReById;
                request.EqualityFilter = equalFilter;
            }
            return true;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }
    }
}